import * as React from 'react';
import InternalAvatar from './Avatar';
import Group from './Group'; // export { AvatarProps } from './avatar';
// export { GroupProps } from './group';

var Avatar = InternalAvatar;
Avatar.Group = Group;
export { Group };
export default Avatar;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-avatar/src/index.js